"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
/* eslint-disable no-empty-pattern */
/* eslint-disable no-async-promise-executor */
const vue_1 = __importDefault(require("vue"));
const vuex_1 = __importDefault(require("vuex"));
const axios_1 = __importDefault(require("axios"));
const GameConst_1 = require("../../constants/GameConst");
const NotiDTO_1 = require("../../models/NotiDTO");
vue_1.default.use(vuex_1.default);
const state = {
    // Display state of components
    menuWindow: false,
    notificationModal: false,
    helpMenu: false,
    guideMenu: false,
    systemRequirementModal: false,
    userRegisterWindow: false,
    maintenanceDialog: false,
    // Data of notification
    notiData: null,
    currentItemDetail: null,
};
const mutations = {
    showComponent(state, { component, isShow }) {
        state[component] = isShow;
        if (component !== 'menuWindow') {
            state.menuWindow = !isShow;
        }
    },
    setNotiData(state, data) {
        state.notiData = data;
    },
    setItemDetail(state, data) {
        state.currentItemDetail = data;
    },
};
const actions = {
    getAllNotice({ commit }) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const url = `${GameConst_1.SERVER_ADDRESS}notice`;
            const listNotice = [];
            try {
                const response = yield axios_1.default.get(url);
                const { data } = response;
                data.forEach((noticeData) => {
                    const notice = NotiDTO_1.NotiDTO.fromJson(noticeData);
                    listNotice.push(notice);
                });
                commit('setNotiData', listNotice);
                resolve();
            }
            catch (error) {
                reject(error);
            }
        }));
    },
    getNoticeBody({}, notice) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const url = `${GameConst_1.SERVER_ADDRESS}notice/${notice.id}`;
            try {
                const response = yield axios_1.default.get(url);
                const { data } = response;
                notice.body = data.body;
                resolve();
            }
            catch (error) {
                reject(error);
            }
        }));
    },
};
exports.store = new vuex_1.default.Store({
    state,
    mutations,
    actions,
});
